const headerTitleStyle = (theme) => ({
  titleWrapper: {
    margin: 0,
    maxWidth: "40%",
    flex: "1 0 auto",
    display: "flex",
  },
  title: {
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
  },
  link: {
    color: theme.palette.common.white,
    display: "flex",
    alignItems: "center",
    marginRight: theme.spacing(1),
  },
});

export default headerTitleStyle;
